export default __webpack_public_path__ + "static/media/seamless-wallet.8081355d.png";